
import { AloDbRole } from '@/models/alodb/AloDbRole'
import { FilterBase } from '@/models/filter/FilterBase';

export interface IRoleState {
    status:string
    roles: Array<AloDbRole>
    modifiedAdmRole: AloDbRole
    originalAdmRole: AloDbRole
    roleLoading: boolean
    adminFilter: FilterBase
}
  
const state:IRoleState = { 
    status: '',
    roles: [],
    modifiedAdmRole: new AloDbRole(),
    originalAdmRole: new AloDbRole(),
    roleLoading:false,
    adminFilter: new FilterBase()
}
  
export default state